function toggleLineClamp() {
  let button = $('.packages__subtitle');
  button.on('click', function() {
    $(this).toggleClass('active');
  });
}
toggleLineClamp();